import Vue from "vue";
import Tooltip from "./index.vue";

const events = ["error", "warning", "success", "info"];

Tooltip.install = function(vm) {
  vm.component(Tooltip.name, Tooltip);
};

events.forEach((event) => {
  Tooltip[event] = function(options) {
    let handleOpt = options;
    if(typeof options !== 'object'){
       handleOpt = {
        msg: options
      }
    }
    const initOpt = {
      msg:'',
      time:3000
    }
    const opt = Object.assign({},initOpt,handleOpt)
    const instance = new Vue({
      render(h) {
        return h(Tooltip, { props: { options: opt, type: event } });
      },
    });
    
    const div = document.createElement("div");
    document.body.appendChild(div);
    instance.$mount(div);

    const time = opt.time;
    let timer = setTimeout(()=>{
      instance.$el.parentNode.removeChild(instance.$el);
      clearTimeout(timer)
      this.timer = null
    },time)

  };
});
export default Tooltip;
